import React, { ReactNode } from 'react'

interface IContent {
    // title: string;
    className?: string,
    // isShowTitle?: boolean,
    children?: ReactNode
}

const ChatContainer = ({
    // title,
    className = '',
    // isShowTitle = true, // Set default value to true
    children
}: IContent) => {
    return (
        <div className={`flex flex-col ${className}`}>
            {/* {isShowTitle && <h1 className='text-2xl text-white font-semibold'> {title}</h1>} */}
            {children}
        </div>
    )
}

export default ChatContainer